import Container from '@/components/@base/container';
import cn from '@/lib/clsxm';
import { useGetAdvertisement } from '@/services/hooks';
import ThreeDotLoading from '@/components/@base/three-dot-loading/ThreeDotLoading';
import { useSearchParams } from 'react-router-dom';

const PageLoader = () => {
  const [searchParams] = useSearchParams();
  const {data:advertiseInOtp} = useGetAdvertisement(11, searchParams.get('pgc') as string)
  return <Container className='fixed flex flex-col z-[10000000000] loading_page mx-auto max-w-[448px]' style={{top: '-100px', left: '0', right:'0', bottom:'-100px'}}>

    <Container center className="w-full border-b border-grayLight-40 dark:border-grayDark-900 justify-between px-4 h-16 mt-32">
      <Container className='w-20 h-4 relative bg-grayLight-40 dark:bg-grayDark-900 rounded-md overflow-hidden'>
        <Container  className=' loading-asset'/>
      </Container>
      <Container className='w-20 h-4 relative bg-grayLight-40 dark:bg-grayDark-900 rounded-md overflow-hidden'>
        <Container  className=' loading-asset'/>
      </Container>
    </Container>
    <Container center className="w-full justify-start gap-3 p-4">
      <Container className='w-10 h-10 relative bg-grayLight-40 dark:bg-grayDark-900 rounded-full overflow-hidden'>
        <Container  className=' loading-asset'/>
      </Container>
      <Container className='w-20 h-4 relative bg-grayLight-40 dark:bg-grayDark-900 rounded-md overflow-hidden'>
        <Container  className=' loading-asset'/>
      </Container>
    </Container>
    <Container center className="w-full justify-start gap-3 border-b border-grayLight-40 dark:border-grayDark-900 p-4">
      <Container className='w-10 h-10 relative bg-grayLight-40 dark:bg-grayDark-900 rounded-full overflow-hidden'>
        <Container  className=' loading-asset'/>
      </Container>
      <Container className='w-20 h-4 relative bg-grayLight-40 dark:bg-grayDark-900 rounded-md overflow-hidden'>
        <Container  className=' loading-asset'/>
      </Container>
    </Container>
    <Container center className="w-full justify-start p-4 pt-10">
      <Container className='w-20 h-4 relative bg-grayLight-40 dark:bg-grayDark-900 rounded-md overflow-hidden'>
        <Container  className=' loading-asset'/>
      </Container>
    </Container>
    <Container center className="w-full justify-between gap-3 p-4">
      <Container className="gap-3" center>
      <Container className='w-14 h-10 relative bg-grayLight-40 dark:bg-grayDark-900 rounded-md overflow-hidden'>
        <Container  className=' loading-asset'/>
      </Container>
      <Container className='w-28 h-4 relative bg-grayLight-40 dark:bg-grayDark-900 rounded-md overflow-hidden'>
        <Container  className=' loading-asset'/>
      </Container>
      </Container>
      <Container className='w-4 h-4 relative bg-grayLight-40 dark:bg-grayDark-900 rounded-md overflow-hidden'>
        <Container  className=' loading-asset'/>
      </Container>
    </Container>
    <Container center className="w-full justify-between gap-3 p-4">
      <Container className="gap-3" center>
        <Container className='w-14 h-10 relative bg-grayLight-40 dark:bg-grayDark-900 rounded-md overflow-hidden'>
          <Container  className=' loading-asset'/>
        </Container>
        <Container className='w-28 h-4 relative bg-grayLight-40 dark:bg-grayDark-900 rounded-md overflow-hidden'>
          <Container  className=' loading-asset'/>
        </Container>
      </Container>
      <Container className='w-4 h-4 relative bg-grayLight-40 dark:bg-grayDark-900 rounded-md overflow-hidden'>
        <Container  className=' loading-asset'/>
      </Container>
    </Container>
    <Container center className="w-full justify-between gap-3 p-4">
      <Container className="gap-3" center>
        <Container className='w-14 h-10 relative bg-grayLight-40 dark:bg-grayDark-900 rounded-md overflow-hidden'>
          <Container  className=' loading-asset'/>
        </Container>
        <Container className='w-28 h-4 relative bg-grayLight-40 dark:bg-grayDark-900 rounded-md overflow-hidden'>
          <Container  className=' loading-asset'/>
        </Container>
      </Container>
      <Container className='w-4 h-4 relative bg-grayLight-40 dark:bg-grayDark-900 rounded-md overflow-hidden'>
        <Container  className=' loading-asset'/>
      </Container>
    </Container>

    {advertiseInOtp && advertiseInOtp?.ads?.length > 0 && advertiseInOtp?.ads[0]?.banner && advertiseInOtp?.ads[0]?.banner?.length > 0 && (
      <Container center className='fixed bottom-20 px-4 max-w-[448px]'>
        <img
          src={advertiseInOtp?.ads[0]?.banner}
          alt='ads'
          className={cn('min-h-10 w-full rounded-lg mb-4')}
        />
        <ThreeDotLoading className="bottom-12"/>
      </Container>
    )}
  </Container>
}

export default PageLoader;